import React from 'react';

export const Svg = ({id}) => (
    <svg>
        <use xlinkHref={id}/>
    </svg>
);
